import React from 'react';
import { FormItem } from '@carbon/react';
import DndUploader from 'src/components/Uploader/DNDUploader';
import { getImageUrl } from 'src/utils/images';

interface ImageFieldProps {
  title: string;
  description: string;
  aspectRatio: string;
  cropperAspectRatio: number;
  value: string | null;
  onChange: (fileId: string | null) => void;
}

/**
 * A thin wrapper, not a new uploader. `DNDUploader` calls back with `{ fileId }` and
 * `RestaurantInformationSettings` stores it verbatim; this does the same, so a storefront
 * image is stored exactly like a restaurant logo and the storefront app's `imageUrl()` can
 * treat both identically.
 *
 * `getImageUrl` is only for the preview. What is stored, sent and returned is the bare object
 * key: on R2 the key is the object name, so an appended extension would name a missing object.
 */
export const ImageField = React.memo(
  ({ title, description, aspectRatio, cropperAspectRatio, value, onChange }: ImageFieldProps) => (
    <FormItem>
      <p className="cds--file--label">{title}</p>
      <p className="cds--label-description">{description}</p>
      <DndUploader
        useCropper
        initialValue={value ? { fileId: value, previewUrl: getImageUrl(value)! } : null}
        previewAspectRatio={aspectRatio}
        cropperAspectRatio={cropperAspectRatio}
        onChange={(data) => onChange(data.fileId ?? null)}
      />
    </FormItem>
  )
);

export default ImageField;
